import { componentScope, h } from "harmaja"
import * as L from "lonna"
import { Board, EventFromServer } from "../../../../common/src/domain"
import { Dispatch } from "../../store/board-store"

// Shared countdown timer. State lives on the server in memory and is broadcast as "board.timer".
export const TimerView = ({
    board,
    dispatch,
    eventsFromServer,
}: {
    board: L.Property<Board>
    dispatch: Dispatch
    eventsFromServer: L.EventStream<EventFromServer>
}) => {
    const endsAt = L.atom<number | null>(null)
    eventsFromServer.forEach((e) => {
        if (e.action === "board.timer") endsAt.set(e.endsAt)
    })
    const setTimer = (t: number | null) => {
        endsAt.set(t)
        dispatch({ action: "board.timer", boardId: board.get().id, endsAt: t })
    }
    const now = L.interval(500, null, componentScope()).pipe(
        L.map(() => Date.now()),
        L.toProperty(Date.now(), componentScope()),
    )
    const remaining = L.view(endsAt, now, (e, n) => (e === null ? null : Math.max(0, Math.ceil((e - n) / 1000))))
    const label = L.view(remaining, (r) =>
        r === null ? "" : `${Math.floor(r / 60)}:${String(r % 60).padStart(2, "0")}`,
    )
    const start = () => {
        const m = parseFloat(prompt("Timer minutes", "5") || "")
        if (m > 0) setTimer(Date.now() + m * 60000)
    }
    return L.view(remaining, (r) =>
        r === null ? (
            <a className="timer board-button" title="Start shared timer" onClick={start}>
                ⏱
            </a>
        ) : (
            <span className={r === 0 ? "timer done" : "timer"}>
                <span className="time" title="Click to stop" onClick={() => setTimer(null)}>
                    {label}
                </span>
                <a title="Add a minute" onClick={() => setTimer(Math.max(endsAt.get()!, Date.now()) + 60000)}>
                    +1
                </a>
            </span>
        ),
    )
}
